import { useState } from 'react'

const useLocalStorage = <T>(key: string, initialValue: T) => {
  const [storedValue, setStoredValue] = useState(() => {
    const item = localStorage.getItem(key)
    return item ? JSON.parse(item) as T : initialValue
  })
  const setValue = (vf: T | ((a: T)=> T)) => {
    if (vf instanceof Function) setStoredValue(v=> {
      const value = vf(v)
      localStorage.setItem(key, JSON.stringify(value))
      return value
    })
    else {
      setStoredValue(vf)
      localStorage.setItem(key, JSON.stringify(vf))
    }
  }
  return [storedValue, setValue] as const
}
export default useLocalStorage